"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DateCountdown = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _coreSpan = _interopRequireDefault(require("@vfuk/core-span"));

var _coreAnimationContainer = _interopRequireDefault(require("@vfuk/core-animation-container"));

var _coreBaseProps = require("@vfuk/core-base-props");

var _secondsToDhms = _interopRequireDefault(require("./utils/secondsToDhms"));

var _TimerBlock = _interopRequireDefault(require("./components/TimerBlock"));

var Styled = _interopRequireWildcard(require("./styles/DateCountdown.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DateCountdown = /*#__PURE__*/function (_PureComponent) {
  _inherits(DateCountdown, _PureComponent);

  var _super = _createSuper(DateCountdown);

  function DateCountdown() {
    var _this;

    _classCallCheck(this, DateCountdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.componentName = 'DateCountdown';
    _this.countdownTimer = null;
    _this.delayTimer = null;
    _this.state = {
      isExpired: false,
      remainingSeconds: 0,
      values: {
        days: 1,
        hours: 0,
        minutes: 0,
        seconds: 0
      }
    };

    _this.timerTick = function () {
      var remainingSeconds = _this.state.remainingSeconds - 1;

      if (remainingSeconds === 0) {
        _this.stopCountdown();

        return;
      }

      _this.setState({
        remainingSeconds: remainingSeconds,
        values: _objectSpread({}, (0, _secondsToDhms["default"])(remainingSeconds))
      });
    };

    return _this;
  }

  _createClass(DateCountdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initialiseTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.delayTimer) {
        this.stopDelay();
      }

      if (this.countdownTimer) {
        this.stopCountdown();
      }
    }
  }, {
    key: "startCountdown",
    value: function startCountdown(delay) {
      var _this2 = this;

      this.delayTimer = setTimeout(function () {
        _this2.delayTimer = null;
        _this2.countdownTimer = setInterval(_this2.timerTick, DateCountdown.timerInterval);
      }, delay * 1000);
    }
  }, {
    key: "stopDelay",
    value: function stopDelay() {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  }, {
    key: "stopCountdown",
    value: function stopCountdown() {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
      this.setState({
        isExpired: true,
        values: {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        }
      });
    }
  }, {
    key: "initialiseTimer",
    value: function initialiseTimer() {
      var now = Date.now();
      var startDate = this.props.startDate ? this.props.startDate : now;
      var remainingSeconds = (0, _dayjs["default"])(this.props.endDate).diff(startDate, 'second');
      var delayStart = (0, _dayjs["default"])(startDate).diff(now, 'second'); // It has not expired

      if (remainingSeconds > 0) {
        this.setState({
          remainingSeconds: remainingSeconds,
          values: _objectSpread({}, (0, _secondsToDhms["default"])(remainingSeconds))
        }); // Delays the start of the timer if needed

        this.startCountdown(delayStart < 0 ? 0 : delayStart);
        return;
      } // It has already expired


      this.setState({
        remainingSeconds: 0,
        isExpired: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$text,
          _this$props$text2,
          _this3 = this;

      return /*#__PURE__*/_react["default"].createElement(Styled.CountdownContainer, _extends({
        size: this.props.size,
        inverse: this.props.inverse,
        justify: this.props.justify,
        id: this.props.id,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
        "data-component-name": this.componentName
      }, this.props.dataAttributes), this.state.isExpired && (_this$props$text = this.props.text) !== null && _this$props$text !== void 0 && _this$props$text.expiry ? /*#__PURE__*/_react["default"].createElement(_coreSpan["default"], {
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'expiry-text')
      }, this.props.text.expiry) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ((_this$props$text2 = this.props.text) === null || _this$props$text2 === void 0 ? void 0 : _this$props$text2.prefix) && /*#__PURE__*/_react["default"].createElement(_coreSpan["default"], {
        inverse: this.props.inverse,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'prefix')
      }, this.props.text.prefix), /*#__PURE__*/_react["default"].createElement(_coreAnimationContainer["default"], null, /*#__PURE__*/_react["default"].createElement(Styled.CountdownTimer, {
        showUnits: this.props.showUnits,
        text: this.props.text,
        size: this.props.size,
        orientation: this.props.orientation,
        role: "timer",
        "aria-live": "off",
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'timer')
      }, DateCountdown.countdownSections.map(function (section, index) {
        if (_this3.props.format && !_this3.props.format[section]) return null;
        return /*#__PURE__*/_react["default"].createElement(Styled.CountdownSection, {
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_TimerBlock["default"], {
          inverse: _this3.props.inverse,
          unit: section,
          showUnit: _this3.props.showUnits && _this3.props.size === 3,
          remainingTime: _this3.state.values[section],
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this3.props.dataSelectorPrefix, section)
        }), /*#__PURE__*/_react["default"].createElement(_coreSpan["default"], {
          inverse: _this3.props.inverse
        }, ":"));
      }))), this.props.text && this.props.text.suffix && /*#__PURE__*/_react["default"].createElement(_coreSpan["default"], {
        inverse: this.props.inverse,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'suffix')
      }, this.props.text.suffix)));
    }
  }]);

  return DateCountdown;
}(_react.PureComponent);

exports.DateCountdown = DateCountdown;
DateCountdown.defaultProps = {
  size: 3,
  justify: 'left'
};
DateCountdown.countdownSections = ['days', 'hours', 'minutes', 'seconds'];
DateCountdown.timerInterval = 1000;
DateCountdown.displayName = "DateCountdown";
var _default = DateCountdown;
exports["default"] = _default;
//# sourceMappingURL=DateCountdown.js.map